var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ruler",style:({
    '--ruler1-space': _vm.lowerTicksSpace,
    '--ruler2-space': _vm.higherTicksSpace,
    '--top': _vm.topDistance + 'px',
    '--left': _vm.leftDistance + 'px',
    '--height': _vm.height + 'px',
    '--width': _vm.width + 'px',
  })},[_c('ul',{staticClass:"ruler-x"},[_c('li'),_vm._l((_vm.points),function(point){return _c('li',{key:point},[_vm._v(_vm._s(point))])})],2),_c('ul',{staticClass:"ruler-y",style:({ '--top': _vm.topDistance + 'px' })},[_c('li',{staticClass:"ruler-y__top"}),_vm._l((_vm.points),function(point){return _c('li',{key:point},[_vm._v(_vm._s(point))])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }